import React, { useState } from 'react'
import PropTypes from 'prop-types'

import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'

import { Dropzone } from '../../../../Components/Form/Dropzone'
import { formatUserRoleName, LEGAL_DOCUMENT_FORM_MODES } from '../const'
import SubmitButton from '../../../../Components/Form/SubmitButton'
import { ROLE_DISTRIBUTOR, ROLE_SPY } from '../../../../shared/constants'

const styles = {
  card: { padding: '2.5rem', marginBottom: '2rem' },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
}

const LegalDocumentsForm = ({
  classes,
  defaultValues,
  countries,
  handleSubmit,
  mode,
  handleCancel,
  buttonsDisabled,
}) => {
  const initialFormValues = {
    name: defaultValues.name || '',
    url: defaultValues.url || '',
    countryId: defaultValues.countryId || '',
    userRole: defaultValues.userRole || ROLE_DISTRIBUTOR,
  }

  const [formValues, setFormValues] = useState(initialFormValues)
  const [submitted, setSubmitted] = useState(false)
  const [file, setFile] = useState(null)

  const isFormValid =
    formValues.name.length &&
    (mode === LEGAL_DOCUMENT_FORM_MODES.CREATE
      ? !!file
      : formValues.url.length) &&
    formValues.userRole

  const handleInputChange = e =>
    setFormValues({ ...formValues, [e.target.name]: e.target.value })

  const handleFormSubmit = () => {
    setSubmitted(true)
    if (isFormValid) handleSubmit({ ...formValues, file })
  }

  const handleFormCancel = () =>
    typeof handleCancel === 'function' ? handleCancel() : window.history.back()

  return (
    <React.Fragment>
      <Typography className={classes.title} variant="h4">
        {mode === LEGAL_DOCUMENT_FORM_MODES.CREATE
          ? 'Create new legal document'
          : 'Edit legal document'}
      </Typography>

      <Card className={classes.card}>
        <TextField
          fullWidth
          margin="normal"
          required
          label="Name"
          name="name"
          error={submitted && formValues.name.length === 0}
          value={formValues.name}
          onChange={handleInputChange}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel shrink>Country</InputLabel>
          <Select
            id="demo-simple-select"
            name="countryId"
            displayEmpty
            value={formValues.countryId}
            onChange={handleInputChange}
          >
            <MenuItem value="">All countries</MenuItem>
            {(!Array.isArray(countries) || countries.length === 0) && (
              <MenuItem disabled>Loading...</MenuItem>
            )}
            {Array.isArray(countries) &&
              countries.map(country => (
                <MenuItem value={country.id} key={country.id}>
                  {country.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel shrink>User Role</InputLabel>
          <Select
            id="demo-simple-select"
            name="userRole"
            displayEmpty
            value={formValues.userRole}
            onChange={handleInputChange}
          >
            {[ROLE_DISTRIBUTOR, ROLE_SPY].map(role => (
              <MenuItem value={role} key={role}>
                {formatUserRoleName[role]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {mode === LEGAL_DOCUMENT_FORM_MODES.EDIT && (
          <TextField
            fullWidth
            margin="normal"
            required
            label="URL"
            name="url"
            disabled
            error={submitted && formValues.url.length === 0}
            value={formValues.url}
            onChange={handleInputChange}
          />
        )}

        <Dropzone
          mainLabel={
            mode === LEGAL_DOCUMENT_FORM_MODES.CREATE
              ? 'Legal Document'
              : 'Update legal document'
          }
          input={{
            value: '',
            onChange: files => setFile(files[0]),
          }}
          meta={{}}
        />
      </Card>
      <div className={classes.buttonsWrapper}>
        <SubmitButton
          variant="outlined"
          disabled={buttonsDisabled}
          value="Cancel"
          onClick={handleFormCancel}
        />
        <SubmitButton
          disabled={!isFormValid || submitted || buttonsDisabled}
          variant="contained"
          value="Submit"
          onClick={handleFormSubmit}
        />
      </div>
    </React.Fragment>
  )
}
LegalDocumentsForm.propTypes = {
  classes: PropTypes.object.isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    countryId: PropTypes.string,
    userRole: PropTypes.string,
  }),
  mode: PropTypes.oneOf(Object.values(LEGAL_DOCUMENT_FORM_MODES)),
  buttonsDisabled: PropTypes.bool,
}

LegalDocumentsForm.defaultProps = {
  mode: LEGAL_DOCUMENT_FORM_MODES.CREATE,
  defaultValues: {},
}

export default withStyles(styles)(LegalDocumentsForm)



// WEBPACK FOOTER //
// ./src/Containers/Settings/LegalDocumentation/LegalDocumentForm/LegalDocumentForm.jsx